export default __webpack_public_path__ + "static/media/london bridge.fedbd25b.svg";